import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import { Button, Checkbox, Col, Dropdown, Input, Menu, Row, Select, Space, Switch, Table, Tooltip } from "antd";


const MasterLinkShipping = () => {
  const { t } = useTranslation();
  const columns = [
    {
      title: (
        <Tooltip title={t("Configurable Attribute")}>
          {t("Configurable Attribute")}
        </Tooltip>
      ),
      ellipsis: true,
      dataIndex: "config",
    },
    {
      title: (
        <Tooltip title={t("Shipping Charge")}>{t("Shipping Charge")}</Tooltip>
      ),
      ellipsis: true,
      dataIndex: "shipping_charge",
    },
    {
      title: <Tooltip title={t("Active")}>{t("Active")}</Tooltip>,
      ellipsis: true,
      dataIndex: "active",
    },
  ];

  const data = [
    {
      key: "1",
      config: <span>{t("Super Saver Shipping (5-9 business days)")}</span>,
      shipping_charge: (
        <div className="inpt__div">
          <span>$</span>
          <input type="number" placeholder="20" />
        </div>
      ),
      active: <input type="checkbox" id="1" />,
    },
    {
      key: "2",
      config: <span>{t("Standard Shipping (3-5 business days)")}</span>,
      shipping_charge: (
        <div className="inpt__div">
          <span>$</span>
          <input type="number" placeholder="20" />
        </div>
      ),
      active: <input type="checkbox" id="1" />,
    },
    {
      key: "3",
      config: <span>{t("Two-Day Shipping")}</span>,
      shipping_charge: (
        <div className="inpt__div">
          <span>$</span>
          <input type="number" placeholder="20" />
        </div>
      ),
      active: <input type="checkbox" id="1" />,
    },
    {
      key: "4",
      config: <span>{t("One-Day Shipping")}</span>,
      shipping_charge: (
        <div className="inpt__div">
          <span>$</span>
          <input type="number" placeholder="20" />
        </div>
      ),
      active: <input type="checkbox" id="1" />,
    },
    {
      key: "4",
      config: <span>{t("Overnight Shipping with Saturday Delivery")}</span>,
      shipping_charge: (
        <div className="inpt__div">
          <span>$</span>
          <input type="number" placeholder="20" />
        </div>
      ),
      active: <input type="checkbox" id="1" />,
    },
    {
      key: "4",
      config: <span>{t("Overnight Shipping (No Saturday Delivery)")}</span>,
      shipping_charge: (
        <div className="inpt__div">
          <span>$</span>
          <input type="number" placeholder="20" />
        </div>
      ),
      active: <input type="checkbox" id="1" />,
    },
    {
      key: "4",
      config: (
        <span>
          {t(
            "International Shipping (Outside the USA) with a Shipping Charge of TBD"
          )}
        </span>
      ),
      shipping_charge: (
        <div className="inpt__div">
          <span>$</span>
          <input type="number" placeholder="0" />
        </div>
      ),
      active: <input type="checkbox" id="1" />,
    },
  ];

  return (
    <React.Fragment>
      <div className="shipping_section form__fields">
        <div className="row">
          <div className="col-lg-12">
            <h4 className="workarea__heading mt-0 mb-0"> {t("Shipping")} </h4>
          </div>

          <div className="col-lg-12 mt-4">
            <div className="shipping_tbldiv">
              <Table columns={columns} dataSource={data} />
            </div>
          </div>

          <div className="col-lg-12">
            <button class="primary-btn"> {t("Update Settings")} </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default MasterLinkShipping;
